import { render, staticRenderFns } from "./DataTableItemFlowBlockType.vue?vue&type=template&id=1b4a9a91&"
import script from "./DataTableItemFlowBlockType.vue?vue&type=script&lang=ts&"
export * from "./DataTableItemFlowBlockType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports